import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { mmkvCropPreference, zustandCropPreference } from '../mmkv/mmkvCropPreference';
import { MMKVStoreKeyMap } from '../mmkv/mmkvStoreKeyMap';
import { ICropPreference } from './interface';
import { Language } from './useEventZStore';
type CropPreferenceStore = {
  cropPreference: Array<ICropPreference>;
  setCropPreference: (payload: Array<ICropPreference>) => void;
  userPreferenceId: string;
  setUserPreferenceId: (payload: string) => void;
  clearCropPreferenceStorage: () => void;
  cropLangaugeByName: string[];
  setCropLangaugeByName: (langaugeByName: string[]) => void;
  animalPreference: Array<ICropPreference>;
  setAnimalPreference: (payload: Array<ICropPreference>) => void;
};

const initialState = {
  cropPreference: [],
  userPreferenceId: '',
  cropLangaugeByName: [],
  animalPreference: [],
};

export const useCropPreferenceStore = create<CropPreferenceStore>()(
  persist(
    (set, get) => ({
      ...initialState,
      setCropPreference: (cropPreference: Array<ICropPreference>) =>
        set(() => ({ cropPreference: cropPreference })),
      setUserPreferenceId: (userPreferenceId: string) =>
        set((state) => ({ userPreferenceId: userPreferenceId })),
      setCropLangaugeByName: (languageName: string[]) =>
        set(() => ({ cropLangaugeByName: languageName })),
      setAnimalPreference: (animalPreference: Array<ICropPreference>) =>
        set(() => ({ animalPreference: animalPreference })),
      clearCropPreferenceStorage: () => {
        mmkvCropPreference.delete(MMKVStoreKeyMap.cropPreferenceStore);
        set(initialState);
      },
    }),
    {
      name: MMKVStoreKeyMap.cropPreferenceStore,
      storage: createJSONStorage(() => zustandCropPreference),
    }
  )
);
